import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { EditedIcon } from '@gem/icons';
import { IconView } from '@gem/ui-kit';

import { MessageViews } from 'APP/components/MessageViews/MessageViews';

import Time from './Time';
import styles from './styles.m.css';

const StatusBar = ({
  message,
  className = '',
  viewsClassName = '',
  showEditIcon = true,
  fixedColor = false,
}) => {
  const showEdit = Boolean(showEditIcon && (message.editedPayload || message.editTime));

  return (
    <div
      className={classNames(styles.statusBar, className, {
        [styles.fixedColor]: fixedColor,
      })}
    >
      {showEdit && (
        <IconView
          Icon={EditedIcon}
          size="small"
          className={styles.edited}
        />
      )}
      <Time
        time={message.displayTime}
        fixedColor={fixedColor}
      />
      <MessageViews
        message={message}
        className={viewsClassName}
        fixedColor={fixedColor}
      />
    </div>
  );
};

export default observer(StatusBar);
